import Vue from 'vue'
import LightBox from 'vue-image-lightbox'
import 'vue-image-lightbox/dist/vue-image-lightbox.min.css'

Vue.component('LightBox', LightBox)
